import { Navbar, Nav, NavDropdown,} from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useMemo } from 'react'; 
import useLayout from '#Context/Layout'
import './navbar.css'

export default function AppNav() {
    const { platform } = useLayout();
    const location = useLocation();
    const page = useMemo(() => {
        //in order to handle nested routes, like /blog/Welcome, only want first path segment
        return '/' + location.pathname.split('/')[1]
    }, [location])
    const [showing, setShowing] = useState(false)

    //in each LinkContainer, couldn't just apply active as part of className, wasn't getting handled properly by React-router, made into a react prop 'active' instead
    return (
        <Navbar variant="dark" className={`ps-3 ${platform !== 'desktop' && 'shadow'}`} style={{ height: '13dvh', position:'fixed', top: 0, width: '100vw', zIndex: 1020 }}>
            <Nav  className="align-self-center">
                <LinkContainer to="/" className="d-flex" disabled={page === '/'} active={page === '/'}>
                    <Nav.Link id="homeLink" style={{ color: 'var(--lightish)', textDecoration: 'none' }}>
                        <h4 className="fa fa-home m-0 d-md-none"></h4>
                        <h1 className="fa fa-home m-0 d-none d-md-block"></h1>
                    </Nav.Link>
                </LinkContainer>
            </Nav>
            <Nav className="align-self-center d-lg-none d-xl-block">
                <div className="d-flex flex-column ms-3 rocky" style={{ color: 'var(--light)'}}>
                    <p className="m-0 fs-5">Patrick Mikes,</p>
                    <LinkContainer to="/contact"><Nav.Link className="m-0 p-0" style={{ color: 'var(--light)' }}>patmikesdev@gmail.com</Nav.Link></LinkContainer>
                </div>
            </Nav>
            <Nav className="ms-auto me-2 d-none d-lg-flex wideNav align-self-center rocky" style={{borderBottom: '1px solid var(--medium)'}}>
                <LinkContainer to="/resume" className={`${page === '/resume' ? 'disabled px-3 pt-2' : ''}`} active={page === '/resume'}>
                    <Nav.Link className="pb-0">
                        <i className="fa fa-clipboard-list align-self-center" style={{ width: '1.5rem' }} /><span>Résumé</span>
                    </Nav.Link>
                </LinkContainer>
                <div className="align-self-end mx-3" style={{backgroundColor:'var(--medium)', width: '1px', height: '12px'}}></div>
                <LinkContainer to="/about" className={`${page === '/about' ? 'disabled px-3 pt-2' : ''}`} active={page === '/about'}>
                    <Nav.Link className="pb-0">
                        <i className="fa fa-dna align-self-center" style={{ width: '1.5rem' }} /><span>About Me</span>
                    </Nav.Link>
                </LinkContainer>
                <div className="align-self-end mx-3" style={{backgroundColor:'var(--medium)', width: '1px', height: '12px'}}></div>
                <LinkContainer to="/projects" className={`${page === '/projects' ? 'disabled px-3 pt-2' : ''}`} active={page === '/projects'}>
                    <Nav.Link className="pb-0">
                        <i className="fa fa-tools align-self-center" style={{ width: '1.5rem' }} /><span>Projects</span>
                    </Nav.Link>
                </LinkContainer>
                <div className="align-self-end mx-3" style={{backgroundColor:'var(--medium)', width: '1px', height: '12px'}}></div>
                <LinkContainer to="/blog" className={`${page === '/blog' ? 'disabled px-3 pt-2' : ''}`} active={page === '/blog'}>
                    <Nav.Link className="pb-0">
                        <i className="fa fa-blog align-self-center" style={{ width: '1.5rem' }} /><span>Developer Blog</span>
                    </Nav.Link>
                </LinkContainer>
                <div className="align-self-end mx-3" style={{backgroundColor:'var(--medium)', width: '1px', height: '12px'}}></div>
                <LinkContainer to="/contact" className={`${page === '/contact' ? 'disabled px-3 pt-2' : ''}`} active={page === '/contact'}>
                    <Nav.Link className="pb-0 me-3">
                        <i className="fa fa-comments align-self-center" style={{ width: '1.5rem' }} /><span>Contact me</span>
                    </Nav.Link>
                </LinkContainer>
            </Nav>
            <Nav className={`ms-auto me-2 me-sm-4 me-md-5 d-lg-none mobileNav align-self-center ${window.innerWidth >= 768 ? 'largeDropdownFont' : ""}`}>
                <NavDropdown onToggle={() => setShowing(!showing)} title={<h1 className={`align-self-center m-0 m-md-2 fa fa-${showing ? `chevron-circle-right` : `bars`}`}></h1>} id="OptionsDropdown" drop="start" /*align="end"*/>
                    <LinkContainer to="/resume" className={`${page === '/resume' ? 'disabled' : ''}`} active={page === '/resume'}>
                        <NavDropdown.Item className="d-flex justify-content-between my-2" ><span>Résumé</span><i className="fa fa-clipboard-list align-self-center ms-3" style={{ width: '1.5rem' }} /></NavDropdown.Item>
                    </LinkContainer>
                    <hr className="my-0 text-light" />
                    <LinkContainer to="/about" className={`${page === '/about' ? 'disabled' : ''}`} active={page === '/about'}>
                        <NavDropdown.Item className="d-flex justify-content-between my-2" ><span>About Me</span><i className="fa fa-dna align-self-center ms-3" style={{ width: '1.5rem' }} /></NavDropdown.Item>
                    </LinkContainer>
                    <hr className="my-0 text-light" />
                    <LinkContainer to="/projects" className={`${page === '/projects' ? 'disabled' : ''}`} active={page === '/projects'}>
                        <NavDropdown.Item className="d-flex justify-content-between my-2" ><span>Projects</span><i className="fa fa-tools align-self-center ms-3" style={{ width: '1.5rem' }} /></NavDropdown.Item>
                    </LinkContainer>
                    <hr className="my-0 text-light" />
                    <LinkContainer to="/blog" className={`${page === '/blog' ? 'disabled' : ''}`} active={page === '/blog'}>
                        <NavDropdown.Item className="d-flex justify-content-between my-2" ><span>Developer Blog</span><i className="fa fa-blog align-self-center ms-3" style={{ width: '1.5rem' }} /></NavDropdown.Item>
                    </LinkContainer>
                    <hr className="my-0 text-light" />
                    <LinkContainer to="/contact" className={`${page === '/contact' ? 'disabled' : ''}`} active={page === '/contact'}>
                        <NavDropdown.Item className="d-flex justify-content-between my-2" ><span>Contact me</span><i className="fa fa-comments align-self-center ms-3" style={{ width: '1.5rem' }} /></NavDropdown.Item>
                    </LinkContainer>
                </NavDropdown>
            </Nav>
        </Navbar>
    )
}